export default __webpack_public_path__ + "1f8cb9e48ca80370a892b58cdefe3297.png";